"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConcreteSubscription = exports.ConcretePublisher = void 0;
/**
 * An Object that represent the subscription to a Publisher.
 */
var ConcreteSubscription = /** @class */ (function () {
    function ConcreteSubscription(publisher, subscriber) {
        this.publisher = null;
        this.subscriber = null;
        this.publisher = publisher;
        this.subscriber = subscriber;
    }
    ConcreteSubscription.prototype.unsubscribe = function () {
        if (this.publisher === null || this.subscriber === null)
            throw new Error('ConcreteSubscription: Invalid state');
        var observerIndex = this.publisher.subscribers.indexOf(this.subscriber);
        if (observerIndex === -1) {
            return console.log('ConcreteSubscription: Nonexistent subscriber.');
        }
        this.publisher.subscribers.splice(observerIndex, 1);
    };
    return ConcreteSubscription;
}());
exports.ConcreteSubscription = ConcreteSubscription;
/**
 * A simple publisher.
 */
var ConcretePublisher = /** @class */ (function () {
    function ConcretePublisher() {
        this.subscribers = [];
    }
    ConcretePublisher.prototype.subscribe = function (subscriber) {
        var isExist = this.subscribers.includes(subscriber);
        if (isExist) {
            throw new Error('Publisher: Subscriber has been subscribed already.');
        }
        this.subscribers.push(subscriber);
        return new ConcreteSubscription(this, subscriber);
    };
    ConcretePublisher.prototype.notify = function (value) {
        for (var _i = 0, _a = this.subscribers; _i < _a.length; _i++) {
            var subscriber = _a[_i];
            subscriber.update(value);
        }
    };
    return ConcretePublisher;
}());
exports.ConcretePublisher = ConcretePublisher;
